import React, { useContext, useEffect } from "react";

import { Context } from "../context/contextApi";
import LeftNav from "./LeftNav";
import VideoCard from "./VideoCard";

const Feed = () => {
  const { loading, searchResults } = useContext(Context);

  useEffect(() => {
    document.getElementById("root").classList.remove("custom-h");
  });
  return (
    <div className="flex flex-row h-[calc(100%-56px)]">
      <LeftNav />

      <div className="grow w-[calc(100%-240px)] h-full overflow-y-auto bg-black text-white">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 p-5 ">
          {!loading &&
            searchResults &&
            searchResults.map((items) => {
              if (items.type !== "video") return false;

              return (
                <VideoCard video={items?.video} key={items?.video?.videoId} />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default Feed;
